module.exports = __webpack_public_path__ + "static/media/icon_pause_dark.fa7334d8.svg";